import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { MdClose } from 'react-icons/md';
import { toastAlert } from 'src/utils/toastAlert';

interface Props {
  onClick: any;
  children: React.ReactNode;
  title: any;
  modalSize?: string;
  errorMsg?: string;
  className?: string;
  showModal?: boolean;
  hideCross?: boolean;
  crossContent?: string;
  isDelete?: boolean;
}

const SlideInModal: React.FC<Props> = ({
  className,
  title,
  isDelete,
  showModal,
  children,
  onClick,
  modalSize,
  errorMsg,
  crossContent,
  hideCross,
}) => {
  const [translate, setTranslate] = useState<boolean>(false);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    showModal &&
      setTimeout(() => {
        setTranslate(true);
      }, 100);
  }, [showModal]);

  return ReactDOM.createPortal(
    <div
      ref={modalRef}
      className={`${
        modalSize ? `w-[${modalSize}%]` : 'w-[300px] xl:w-[388px]'
      } h-full absolute duration-500  ${
        translate ? ' translate-0' : 'translate-x-full'
      }`}
    >
      <div
        className={`shadow-[10px_40px_50px_0px_rgba(45,_87,_226,_0.10)] w-full h-full overflow-y-auto relative top-0 right-0 p-0 xl:p-6  ${className}`}
      >
        <div className="flex items-center justify-between px-4 xl:p-0">
          <h5 className="text-xl font-semibold text-text-black font-Outfit leading-[30px]">
            {title}
          </h5>

          {hideCross ? (
            ''
          ) : crossContent ? (
            <div className="text-base font-semibold text-text-black font-Outfit  min-w-[90px] flex justify-end">
              {crossContent}
            </div>
          ) : (
            <MdClose
              onClick={() => {
                setTranslate(false);
                setTimeout(() => {
                  onClick();
                }, 100);
              }}
              size={25}
              fill="#000"
            />
          )}
        </div>
        <div className="my-3">
          {errorMsg && (
            <p className="text-xl text-warning font-semibold text-center py-4">
              {errorMsg}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('sideSliderModal') as HTMLElement
  );
};

export default SlideInModal;
